import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';

function useDeepCompareEffect(callback: React.EffectCallback, dependencies: any[]) {
    const currentDependenciesRef = useRef<any[]>();

    if (!isEqual(currentDependenciesRef.current, dependencies)) {
        currentDependenciesRef.current = dependencies;
    }

    useEffect(callback, [currentDependenciesRef.current]);
}

export default useDeepCompareEffect;
